import { render, staticRenderFns } from "./ProductionNewsFeed.vue?vue&type=template&id=51ec72fe&scoped=true&"
import script from "./ProductionNewsFeed.vue?vue&type=script&lang=js&"
export * from "./ProductionNewsFeed.vue?vue&type=script&lang=js&"
import style0 from "./ProductionNewsFeed.vue?vue&type=style&index=0&id=51ec72fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ec72fe",
  null
  
)

export default component.exports